"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiLogger = void 0;
const pino_1 = require("./pino");
class ApiLogger {
    debug(message) {
        pino_1.logger.debug(message);
    }
    error(message, trace) {
        pino_1.logger.error({ trace }, message);
    }
    log(message) {
        pino_1.logger.info(message);
    }
    verbose(message) {
        pino_1.logger.trace(message);
    }
    warn(message) {
        pino_1.logger.warn(message);
    }
}
exports.ApiLogger = ApiLogger;
//# sourceMappingURL=nestjs-service.js.map